// filterable.js
document.addEventListener('alpine:init', () => {
  // Definir el store de modales
  Alpine.store('modals', {
    modals: {},

    open(modal) {
      this.modals[modal] = true;
    },

    close(modal) {
      this.modals[modal] = false;
    },

    isOpen(modal) {
      return this.modals[modal] || false;
    }
  });

  Alpine.data('ThemeSection_filterable', (section_id) => ({
    focusId: '',
    filterData: [],
    init() {
      // Inicialización del componente
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
      this._observeResultsMutations();
    },
    filterFormSubmit(e, close) {
      this.focusId = e.target.id;
      if (close) {
        Alpine.store('modals').close(close);
      }
      let form = e.target.form;
      if (e.target.tagName.toLowerCase() === 'form') {
        form = e.target;
      }
      const formData = new FormData(form);
      const searchParams = new URLSearchParams(formData);
      searchParams.delete('price_range');
      this.renderPage(searchParams.toString(), e);
    },
    clearAllFilters(e, formId) {
      // Cerrar todos los modales relacionados
      Alpine.store('modals').close('filters');
      Alpine.store('modals').close('sort'); // Cerrar también el modal de sort si está abierto

      // Resetear el formulario correspondiente
      const form = document.getElementById(formId);
      if (form) {
        form.reset();
        this.renderPage(new URL(form.action).searchParams.toString());
      }
    },
    renderPage(searchParams, event, updateURLHash = true) {
      document.getElementById('facets-results').classList.add('opacity-50');
      const url = `${window.location.pathname}?section_id=${section_id}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      this.filterData.some(filterDataUrl)
        ? this.renderFromCache(filterDataUrl, event)
        : this.renderFromFetch(url, event);
      if (updateURLHash) this.updateURLHash(searchParams);
    },
    renderFromFetch(url, event) {
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          this.filterData = [...this.filterData, { html, url }];
          this.renderMarkup(html);
        });
    },
    renderFromCache(filterDataUrl, event) {
      const html = this.filterData.find(filterDataUrl).html;
      this.renderMarkup(html);
    },
    renderMarkup(html) {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const innerHTML = parsed.getElementById('facets-filterable').innerHTML;
      const filterableEl = document.getElementById('facets-filterable');

      if (innerHTML !== filterableEl.innerHTML) {
        filterableEl.closest('.shopify-section').dispatchEvent(
          new CustomEvent('shapes:section:willmutate', {
            bubbles: true,
          })
        );

        setTimeout(() => {
          filterableEl.querySelectorAll('[x-teleport]').forEach((el) => {
            el.remove();
          });

          filterableEl.innerHTML = innerHTML;

          this.$nextTick(() => {
            // Inicializa teleport si es necesario
            if (typeof initTeleport === 'function') {
              initTeleport(filterableEl);
            }
          });
        }, 300);
      } else {
        document
          .getElementById('facets-results')
          .classList.remove('opacity-50');
      }

      const count = parsed.getElementById('facets-results-count')?.innerHTML || '';
      if (count) {
        liveRegion(count);
      }

      const element = document.getElementById(this.focusId);

      if (element) {
        setTimeout(() => {
          element.focus();
        }, 50);
      }
    },
    updateURLHash(searchParams) {
      history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${searchParams ? '?' + searchParams : ''}`
      );
    },
    onHistoryChange(event) {
      const searchParams = event.state?.searchParams || '';
      this.renderPage(searchParams, null, false);
    },
    _observeResultsMutations() {
      const containerEl = document.getElementById('facets-filterable');

      const mutationObserverOptions = {
        childList: true,
        attributes: false,
        subtree: false,
      };

      const callback = (mutationList, observer) => {
        mutationList.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.target.closest('.shopify-section').dispatchEvent(
              new CustomEvent('shapes:section:hasmutated', {
                bubbles: true,
              })
            );
          }
        });
      };

      const mutationObserver = new MutationObserver(callback);
      mutationObserver.observe(containerEl, mutationObserverOptions);
    },
  }));
});
